module.exports = __webpack_public_path__ + "ae45224bca86fc45f90eb6454f6e609a.svg";